import {
  getRecentTransferAccountsKey,
  TRANSFER_RECENTS_GROUP,
  type SourceDestinationOption,
} from '@src/containers/Transfers/types';

export function recordRecentTransferAccount(
  recentAccounts: Record<string, string[]>,
  provider: string,
  asset: string,
  marketAccountName: string,
  maxAccounts: number
): Record<string, string[]> {
  const key = getRecentTransferAccountsKey(provider, asset);
  const existing = recentAccounts[key] ?? [];
  const deduped = existing.filter(name => name !== marketAccountName);
  const next = [marketAccountName, ...deduped].slice(0, maxAccounts);

  return {
    ...recentAccounts,
    [key]: next,
  };
}

export function resolveRecentTransferAccounts(
  recentAccountNames: string[] | undefined,
  options: SourceDestinationOption[],
  maxAccounts: number
): SourceDestinationOption[] {
  if (recentAccountNames == null || recentAccountNames.length === 0) {
    return [];
  }

  const optionsByName = new Map(options.map(option => [option.marketAccount.Name, option]));

  return recentAccountNames
    .flatMap(name => {
      const option = optionsByName.get(name);
      return option != null ? [option] : [];
    })
    .slice(0, maxAccounts);
}

export function buildOptionsWithRecentsGroup(
  options: SourceDestinationOption[],
  recentAccountNames: string[] | undefined,
  maxAccounts: number
): {
  optionsWithRecents: SourceDestinationOption[];
  getGroup: (option: SourceDestinationOption) => string;
} {
  const recentOptions = resolveRecentTransferAccounts(recentAccountNames, options, maxAccounts);
  const recentClones = recentOptions.map(option => ({ ...option }));
  const recentCloneSet = new WeakSet(recentClones);

  return {
    optionsWithRecents: [...recentClones, ...options],
    getGroup: (option: SourceDestinationOption) =>
      recentCloneSet.has(option) ? TRANSFER_RECENTS_GROUP : (option.marketAccount.TypeDescription ?? 'Other'),
  };
}

export function sourceDestinationEqualityChecker(a: SourceDestinationOption, b?: SourceDestinationOption): boolean {
  if (b == null) {
    return false;
  }
  return a.marketAccount.MarketAccountID === b.marketAccount.MarketAccountID;
}
